<template>
  <div>
    <div class="parent" :class="[!showDetails ? 'parent-2' : '']">
      <v-card @click="showCoursefun">
        <v-card-title class="info-title">
          <div class="text-center">
            {{ payeh.PayehName }}
          </div>
        </v-card-title>
        <div>
          <app-row
            icon="question-circle"
            title="وضعیت:"
            :value="payeh.Status"
          />
          <app-row icon="calculator" title="معدل:" :value="payeh.Avrg" />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["payeh", "index", "showDetails"],
  components: {
    appRow: DetailRow,
  },

  methods: {
    showCoursefun() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
};
</script>


